import * as log from 'loglevel';
import visa from '../assets/images/visa.png';
import mastercard from '../assets/images/mastercard.png';
import amex from '../assets/images/amex.png';
import discover from '../assets/images/discover_card.png';

export default {
  data() {
    return {
      activePlanId: '2c92c0f96832337a0168389651e40bf4',
      activePlan: null,
      activePlanCharges: null,
      cardBrand: null,
      // pricing: null,
      loading: false,
      zuoraErrorMessage: '',
      visa,
      mastercard,
      amex,
      discover,
      adyenForm: {
        loading: false,
        loadEndTime: 0,
        loadStartTime: 0,
        loadingThreshold: 10000, // wait for 10 seconds for form load before throwing error
        loadWatcher: null,
      },
    };
  },
  computed: {
    plansLoaded() {
      if (this.$store.getters.plansLoaded) {
        // this.setPricingPlans();
      }
      return this.$store.getters.plansLoaded;
    },
    cardType() {
      if (this.cardBrand === 'visa') {
        return 'visa';
      }
      if (this.cardBrand === 'mc') {
        return 'mc';
      }
      if (this.cardBrand === 'amex') {
        return 'amex';
      }
      if (this.cardBrand === 'discover') {
        return 'discover';
      }
      return null;
    },
    cardIcon() {
      if (this.cardBrand === 'visa') {
        return this.visa;
      }
      if (this.cardBrand === 'mc') {
        return mastercard;
      }
      if (this.cardBrand === 'amex') {
        return amex;
      }
      if (this.cardBrand === 'discover') {
        return discover;
      }
      return null;
    },
    isAnnualGift() {
      const { userSubscription } = this.$store.getters;
      return !!(userSubscription && userSubscription.plan && userSubscription.plan.type === 'gift_annual');
    },
    isNextChargeAnnualGift() {
      const { userSubscription } = this.$store.getters;
      return !!(userSubscription && userSubscription.next_charge && userSubscription.next_charge.type === 'gift_annual');
    },
    currentPlan() {
      const { userSubscription } = this.$store.getters;
      if (userSubscription.plan && userSubscription.plan.type === 'yearly') {
        return 'Annual';
      }
      if (userSubscription.plan && userSubscription.plan.type === 'gift_annual') {
        return 'Annual Gift';
      }
      return userSubscription.plan && userSubscription.plan.type;
    },
    nextChargePlan() {
      const { userSubscription } = this.$store.getters;
      if (userSubscription.next_charge && userSubscription.next_charge.type === 'yearly') {
        return 'Annual';
      }
      if (userSubscription.next_charge && userSubscription.next_charge.type === 'gift_annual') {
        return 'Annual Gift';
      }
      return userSubscription.next_charge.type;
    },
    isNextChargePresent() {
      const { userSubscription } = this.$store.getters;
      return !!(userSubscription && userSubscription.next_charge);
    },
    renewalDate() {
      const { userSubscription } = this.$store.getters;
      return userSubscription && userSubscription.next_charge && userSubscription.next_charge.renewal_date ? userSubscription.next_charge.renewal_date : null;
    },
  },
  methods: {
    // setPricingPlans() {
    //   this.activePlan = this.$store.getters.activePlan;
    //   this.activePlanCharges = this.$store.getters.activePlanCharges;
    //   if (this.activePlan && this.activePlanCharges) {
    //     this.pricing = this.activePlanCharges.pricing;
    //   }
    // },
    initAdyenForm() {
      const styleObject = {
        base: {
          color: 'black',
          fontSize: '16px',
          fontWeight: '400',
          fontSmoothing: 'antialiased',
          fontFamily: 'inherit',
          maxHeight: '48px',
          minHeight: '48px',
          padding: '0px 0px 0px 0px',
        },
        error: {
          color: 'red',
        },
        placeholder: {
          color: '#c7cbd2',
        },
        validated: {
          color: '#000',
        },
      };
      const csfSetupObj = {
        rootNode: '.cards-div',
        configObject: {
          originKey: process.env.LUMINARY_ADYEN_ORIGIN_KEY,
        },
        paymentMethods: {
          card: {
            sfStyles: styleObject,
            placeholders: {
              encryptedCardNumber: '0000 0000 0000 0000',
              encryptedExpiryMonth: 'MM',
              encryptedExpiryYear: 'YY',
              encryptedSecurityCode: 'CCV',
            },
          },
        },
      };
      this.loading = true;
      this.adyenForm.loading = true;
      this.adyenForm.loadStartTime = (new Date()).getTime();
      this.adyenForm.loadEndTime = 0;
      clearTimeout(this.adyenForm.loadWatcher);
      this.trackAdyenFormLoaded(); // This will log if payment form is not loaded for threshold time window.
      const securedFields = window.csf(csfSetupObj);
      securedFields.onLoad(this.adyenFormLoaded);
      securedFields.onFieldValid(this.adyenFieldValid);
      securedFields.onBrand(this.adyenBrand);
      securedFields.onError(this.adyenError);
    },
    adyenFormLoaded() {
      this.loading = false;
      this.adyenForm.loading = false;
      this.adyenForm.loadEndTime = (new Date()).getTime();
      const diff = (this.adyenForm.loadEndTime - this.adyenForm.loadStartTime) / 1000;
      this.sendAdyenFormLoadTimeInNewRelic(diff);
    },
    adyenFieldValid() {
    },
    adyenBrand(brandObject) {
      this.cardBrand = brandObject.brand;
    },
    adyenError() {
    },
    preventSubmit(e) {
      e.stopPropagation();
    },
    validateForm() {
      let paymentMethod = null;
      this.$refs.paymentForm.validate((valid, data) => {
        if (valid) {
          const encNumber = document.getElementById('card-encrypted-encryptedCardNumber');
          const encSecurityCode = document.getElementById('card-encrypted-encryptedSecurityCode');
          const encExpMonth = document.getElementById('card-encrypted-encryptedExpiryMonth');
          const encExpYear = document.getElementById('card-encrypted-encryptedExpiryYear');

          this.zuoraErrorMessage = '';
          if (!encNumber || !encNumber.value.length) {
            this.zuoraErrorMessage = 'Card number is missing or invalid';
          } else if (!encExpMonth || !encExpMonth.value.length) {
            this.zuoraErrorMessage = 'Card exp. month is missing or invalid';
          } else if (!encExpYear || !encExpYear.value.length) {
            this.zuoraErrorMessage = 'Card exp. year is missing or invalid';
          } else if (!encSecurityCode || !encSecurityCode.value.length) {
            this.zuoraErrorMessage = 'Card security code is missing or invalid';
          }

          if (!this.zuoraErrorMessage.length) {
            paymentMethod = {
              type: 'scheme',
              encryptedCardNumber: encNumber.value,
              encryptedExpiryMonth: encExpMonth.value,
              encryptedExpiryYear: encExpYear.value,
              encryptedSecurityCode: encSecurityCode.value,
            };
            // if (this.update) {
            //   this.updatePaymentInfo(paymentMethod);
            // } else {
            //   this.subscribe(paymentMethod);
            // }
          } else if (document.querySelector('.el-alert')) {
            setTimeout(() => {
              this.scrollToElement('.el-alert');
            }, 500);
          } else {
            setTimeout(() => {
              this.scrollToElement('.el-alert');
            }, 500);
          }
        } else if (data) {
          const keys = Object.keys(data);
          if (keys.length) {
            const dd = data[keys[0]];
            if (dd && dd.length) {
              this.scrollToElement(`#${dd[0].field}`);
            }
          }
        }
      });
      return paymentMethod;
    },
    sendAdyenFormLoadTimeInNewRelic(diff = null) {
      const nrInteraction = window.newrelic.interaction();
      nrInteraction
        .setName('Payment Form')
        .setAttribute('loadTime', diff);
      nrInteraction.save();
      nrInteraction.end();
    },
    trackAdyenFormLoaded() {
      const ctx = this;
      ctx.adyenForm.loadWatcher = setTimeout(() => {
        if (ctx.adyenForm.loading) {
          ctx.sendAdyenFormLoadTimeInNewRelic();
        }
      }, ctx.adyenForm.loadingThreshold);
    },
    resetAdyenEncryptedCardFields() {
      const adyenCardFieldsParent = document.getElementById('js-chckt-pm__pm-holder');
      const encNumber = document.getElementById('card-encrypted-encryptedCardNumber');
      const encSecurityCode = document.getElementById('card-encrypted-encryptedSecurityCode');
      const encExpMonth = document.getElementById('card-encrypted-encryptedExpiryMonth');
      const encExpYear = document.getElementById('card-encrypted-encryptedExpiryYear');

      try {
        if (adyenCardFieldsParent) {
          adyenCardFieldsParent.removeChild(encNumber);
          adyenCardFieldsParent.removeChild(encSecurityCode);
          adyenCardFieldsParent.removeChild(encExpMonth);
          adyenCardFieldsParent.removeChild(encExpYear);
          this.cardBrand = null;
        }
      } catch (err) {
        log.error(err);
      }
    },
  },
};
